import { render } from "./OjtAssessmentSchedule.vue?vue&type=template&id=5e282d14"
import script from "./OjtAssessmentSchedule.vue?vue&type=script&lang=js"
export * from "./OjtAssessmentSchedule.vue?vue&type=script&lang=js"

import "./OjtAssessmentSchedule.vue?vue&type=style&index=0&id=5e282d14&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__